export default __webpack_public_path__ + "static/media/Informs_2022_RLDynamicRisk.8446e81e.pdf";